import { editorContentShiftViewState } from "../..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateTimeValidityMapShift", function updateTimeValidityMapShift(timeKey: string, isValid: boolean) {
    if (editorContentShiftViewState().timeValidityMap) {
        editorContentShiftViewState().timeValidityMap.set(timeKey, isValid);
    }
});